<div class="scrolling">
  <div class="helper-container">
    <header class="header-container" *ngIf="!showConfirmationWindowBool">
      <div class="button-back-container">
        <ion-col size="3">
          <app-back-button (clicked)="salir()" [text]="'Volver'">
          </app-back-button>
        </ion-col>
      </div>
      <ion-toolbar class="ion-no-padding">
        <div class="title-helper">Modifica tu ahorro</div>
        <div class="helper-subtitle mt-6">
          Puedes cambiar la forma en la que quieras aportar.
        </div>
      </ion-toolbar>
    </header>

    <!-- pantalla 1 - ingresar datos -->
    <section *ngIf="!showConfirmationWindowBool">
      <div>
        <form
          (ngSubmit)="frmSubmit(frmModifyAmount)"
          [formGroup]="frmModifyAmount"
        >
          <ion-row>
            <ion-label class="apv-text">{{
              modifyAmount.titleRadiobutton
            }}</ion-label>
          </ion-row>
          <ion-radio-group
            (ionChange)="addDeleteValidatorAmount(); changeCurrency()"
            (click)="changeCurrency()"
            (keypress)="(true)"
            formControlName="currency"
            id="currency-type"
            class="row-radio-buttons mt-10"
            (ionFocus)="focusRadioPills()"
            (ionBlur)="blurRadioPills()"
          >
            <ion-item
              class="container-radio-currency"
              lines="none"
              [class]="
                frmModifyAmount.value.currency === 'pesos'
                  ? 'apv-radio-button-pill-checked'
                  : 'apv-radio-button-pill'
              "
              [class.focus-radio-pills]="isFocusRadioCurrencyPills('pesos')"
            >
              <ion-label class="apv-text" style="color: #1c3a87"
                >{{ currency.pesos }} $</ion-label
              >
              <ion-radio slot="start" value="pesos"></ion-radio>
            </ion-item>
            <ion-item
              class="container-radio-currency"
              lines="none"
              [class]="
                frmModifyAmount.value.currency === 'uf'
                  ? 'apv-radio-button-pill-checked'
                  : 'apv-radio-button-pill'
              "
              [class.focus-radio-pills]="isFocusRadioCurrencyPills('uf')"
            >
              <ion-label class="apv-text" style="color: #1c3a87">{{
                currency.uf
              }}</ion-label>
              <ion-radio slot="start" value="uf"></ion-radio>
            </ion-item>
          </ion-radio-group>
          <ion-row>
            <ion-label class="apv-text mt-30">{{
              modifyAmount.titleAmountInput
            }}</ion-label>
          </ion-row>
          <ion-row>
            <ion-col size="12" class="ion-no-padding">
              <ion-item
                class="apv-input"
                [class]="isValidInputAmount()"
                fill="outline"
                lines="none"
              >
                <span
                  class="mr-12 apv-text font-weight-400"
                  [class.error-color]="isValidAmount()"
                  *ngIf="
                    (isCurrencyFocused &&
                      frmModifyAmount.value.currency == 'pesos') ||
                    (frmModifyAmount.value.amount !== null &&
                      frmModifyAmount.value.currency == 'pesos')
                  "
                  slot="start"
                >
                  $
                </span>
                <span
                  class="mr-12 apv-text font-weight-400"
                  [class.error-color]="isValidAmount()"
                  *ngIf="
                    (isCurrencyFocused &&
                      frmModifyAmount.value.currency == 'uf') ||
                    (frmModifyAmount.value.amount !== null &&
                      frmModifyAmount.value.currency == 'uf')
                  "
                  slot="start"
                  aria-hidden="true"
                  >UF</span
                >
                <span
                  class="mr-12 apv-text font-weight-400"
                  [class.error-color]="isValidAmount()"
                  *ngIf="
                    (isCurrencyFocused &&
                      frmModifyAmount.value.currency == 'porcentaje') ||
                    (frmModifyAmount.value.amount !== null &&
                      frmModifyAmount.value.currency == 'porcentaje')
                  "
                  slot="end"
                  aria-hidden="true"
                  >%</span
                >
                <ion-input
                  text-right
                  id="amount"
                  class="font-weight-600 input-currency-amount"
                  label="{{ inputAmuntPlaceholderLabel }}"
                  label-placement="floating"
                  [class]="formInvalid"
                  [class.label-porcentaje-floating]="
                    isClassLabelPlaceholderActive()
                  "
                  (ionFocus)="currencyChangeFocus()"
                  (ionBlur)="currencyChangeFocus()"
                  formControlName="amount"
                  (keypress)="keyPressNumbers($event)"
                  (ionInput)="addDotsToNumber($event)"
                ></ion-input>
              </ion-item>
            </ion-col>
          </ion-row>
          <ion-row>
            <ion-label
              *ngIf="isValidAmountPesos()"
              class="apv-text-small font-weight-400 min-amount"
            >
              Debe ser mínimo $1.000 y máximo $999.999.999</ion-label
            >

            <ion-label
              *ngIf="isValidAmountUF()"
              class="apv-text-tiny font-weight-400 min-amount"
            >
              Debe ser mínimo 1 UF y máximo 50 UF
            </ion-label>
            <ion-label
              *ngIf="isValidAmountPorcentaje()"
              class="apv-text-tiny font-weight-400 min-amount"
            >
              Debe ser mínimo 1% y máximo 30%
            </ion-label>
            <ion-label
              *ngIf="!isValidAmount()"
              class="apv-text-tiny font-weight-400 current-amount-helper"
            >
              {{ helperTextCurrentDiscount }}
            </ion-label>
          </ion-row>
          <ion-row>
            <div class="notification-subtitle mt-28">
              Notificación a tu empleador
            </div>
            <div class="mt-16 info-notification font-weight-400">
              Por favor, verifica que el correo de tu empleador esté correcto,
              ya que le notificaremos para que realice la modificación de tu
              ahorro.
            </div>
          </ion-row>

          <ion-row [formGroup]="frmModifyAmount">
            <ion-col size="12" class="ion-no-margin ion-no-padding mt-28">
              <div>
                <app-outline-input
                  type="email"
                  formControlName="email"
                  label="Ingresa el correo de tu empleador"
                  errorMessage="Por favor, ingresa un correo para notificarle"
                  (ionChange)="handleMailInputChange()"
                  [isPassword]="false"
                >
                </app-outline-input>
              </div>
            </ion-col>
          </ion-row>
          <ion-row>
            <ion-col>
              <div class="helper-text-executive mt-28 mb-8">
                <ion-checkbox
                  class="checkbox-executive-help"
                  [class.focus-radio-pill-helper]="isFocusReadioExecutive"
                  (ionFocus)="isFocusRadioExecutivePill()"
                  (ionBlur)="isFocusRadioExecutivePill()"
                  formControlName="executiveHelp"
                  slot="start"
                  (click)="addExecutiveHelp()"
                  (keypress)="true"
                ></ion-checkbox>
                <ion-label class="executive-help-label">
                  Recibí ayuda de un ejecutivo
                </ion-label>
              </div>
            </ion-col>
          </ion-row>
          <ion-row
            *ngIf="isExecutiveHelp"
            [formGroup]="frmModifyAmount"
            class="text-secondary mt-8 mb-8"
          >
            <ion-col size="12" class="ion-no-margin ion-no-padding">
              <div>
                <app-outline-input
                  type="rut"
                  formControlName="executiveRut"
                  label="Ingresa RUT del ejecutivo"
                  errorMessage="Por favor, comprueba que el RUT sea correcto"
                  [isPassword]="false"
                >
                </app-outline-input>
              </div>
            </ion-col>
          </ion-row>
        </form>
      </div>
      <ion-row
        class="container-buttons-modal ion-justify-content-between ion-wrap-reverse pt-24"
      >
        <ion-button
          class="cancel-subscription-button ion-justify-content-center"
          [class.on-focus-button-secondary]="isFocusButtonSecondary"
          (ionFocus)="focusButtonSecondary()"
          (ionBlur)="focusButtonSecondary()"
          (click)="salir()"
          (keypress)="true"
          >Salir</ion-button
        >
        <ion-button
          class="continue-subscription-button ion-no-margin ion-no-padding"
          (click)="showConfirmationWindow()"
          (keypress)="true"
          [disabled]="isSubmitButtonDisabled"
          [class]="updateDisbledFormButton()"
          id="modal-modificar-button"
          >Continuar</ion-button
        >
      </ion-row>
    </section>

    <!-- pantalla 2 - confirmar datos -->
    <section *ngIf="showConfirmationWindowBool">
      <confirmation-modal
        (clickVolverButton)="getOutputVolverButton($event)"
      ></confirmation-modal>
    </section>
  </div>
</div>
